<template>
  <section v-if="screenContent" class="scene scene--underground">
    <!-- background -->
    <div class="underlay">
      <div class="underlay wall" />
      <div class="underlay column column--left" />
      <div class="underlay column column--right" />
      <div class="underlay bg-gradient-wall-down" />
    </div>
    <!-- content -->
    <div class="content">
      <div class="content__inner">
        <div class="container text-center">
          <h2 v-if="screenContent.Heading" class="mb-2">
            {{ screenContent.Heading }}
          </h2>
          <p v-if="screenContent.Description" class="portal__text">
            {{ screenContent.Description }}
          </p>
          <!-- btns -->
          <div class="portal__btns flex-row">
            <button
              v-for="(episode, index) in screenContent.EpisodesLinks"
              :key="`episode-${index}`"
              class="btn btn--pink btn--half"
              :class="{ active : checkEpisodeActive(episode) }"
              :disabled="episode.EpisodeUrl === '' ? true : false"
              @click="setActiveEpisode(episode)"
            >
              <span v-if="episode.EpisodeUrl">
                {{ episode.Title }}
              </span>
              <span v-else>
                Coming soon
              </span>
            </button>
          </div>
          <!-- video -->
          <div class="flex-row">
            <div class="col-lg-8 yt-video-container">
              <div
                v-if="activeEpisode"
                class="underlay videoembed__background"
                @click="setActiveEpisode(null)"
              />
              <a v-if="activeEpisode" class="videoembed__close" @click="setActiveEpisode(null)">
                <img alt="Close" src="@/assets/images/landing/icons/close-white.svg" width="29" height="29">
              </a>
              <div class="videoembed" :class="{ 'active' : activeEpisode}">
                <img alt="Video frame" src="@/assets/images/landing/underground/frame.png" class="videoembed__frame">
                <transition name="fade" mode="out-in">
                  <iframe
                    v-if="activeEpisode"
                    :key="activeEpisode.EpisodeUrl"
                    :src="activeEpisode.EpisodeUrl"
                    width="560"
                    height="315"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                  </iframe>
                </transition>
              </div>
            </div>
            <div class="col-lg-4">
              <!-- notice -->
              <div class="notice">
                <img alt="Notice frame" src="@/assets/images/landing/underground/frame.png" class="notice__frame">
                <h5 v-if="screenContent.PromptTitle" class="notice__title">
                  {{ screenContent.PromptTitle }}
                </h5>
                <p v-if="screenContent.PromptText">
                  <b>
                    {{ screenContent.PromptText }}
                  </b>
                </p>
              </div>
            </div>
            <div class="btn-wrapper">
                <a
                  href="/"
                  class="btn btn--pink btn--half"
                  @click="clickFooterLink('Go to Main site')"
                >
                  {{ screenContent.FooterLinkText }}
                </a>

            </div>

            <div class="btn-wrapper">
                <button
                  target="_blank"
                  class="btn btn--pink btn--half"
                  @click="clickPlayNow"
                >
                  {{ screenContent.PromptButtonText }}
                </button>
            </div>
          </div>
        </div>
        <div class="road" />
        <div class="container footer__container text-center">
          <!-- mobile arrow -->
          <button type="button" class="btn btn--pink mb-2 d-none-lg" @click="clickBackToTop">
            {{ screenContent.ButtonTop }}
          </button>
          <!-- footer -->
          <footer class="footer">
            <div v-if="screenContent.SocialLinks" class="footer__links flex-row">
              <a
                v-for="(link, index) in screenContent.SocialLinks"
                :key="`social-${index}`"
                :href="link.Url"
                target="_blank"
                rel="noreferrer"
                @click="clickFooterLink(link.Title)"
              >
                <i class="fab" :class="`fa-${link.Icon}`"></i>
              </a>
            </div>
            <p v-if="screenContent.CopyRights">
              <span>&copy; {{ new Date().getFullYear() }}</span>
              {{ screenContent.CopyRights }}
            </p>
            <div v-if="screenContent.LegalLinks" class="footer__legal flex-row">
              <a
                v-for="(link, index) in screenContent.LegalLinks"
                :key="`legal-${index}`"
                :href="link.Url"
                target="_blank"
                rel="noreferrer"
                @click="clickFooterLink(link.Title)"
              >
                {{ link.Title }}
              </a>
            </div>
          </footer>
        </div>
      </div>
    </div>
    <!-- desktop arrow -->
    <Arrow :text="screenContent.ButtonTop" direction="up" theme="purple" @click="clickBackToTop" />
  </section>
</template>

<script>
import Arrow from '@/components/landing/parts/Arrow.vue'
import Util from '@/services/browser/Util'

export default {
  name: 'Footer',

  components: {
    Arrow
  },

  data () {
    return {
      activeTimeout: null,
      activeEpisode: null
    }
  },

  beforeUnmount () {
    clearTimeout(this.activeTimeout)
  },

  computed: {
    screenContent () {
      return this.$store.getters.getContentFooter
    },
    sceneName () {
      return this.$store.getters.getSceneName
    }
  },

  watch: {
    screenContent () {
      clearTimeout(this.activeTimeout)
      this.setFirstEpisode()
    }
  },

  mounted () {
    this.$gtm.trackEvent({
      'event': 'View Landing Page Section',
      'lp_section': this.sceneName,
      'lp_loc': '3'
    })
    window.scrollTo(0, 0)
    this.activeTimeout = setTimeout(this.setFirstEpisode, 1500)
  },

  methods: {
    setFirstEpisode () {
      if (this.screenContent) {
        if (this.screenContent.EpisodesLinks.length > 0) {
          if (!this.activeEpisode) {
            if (window.innerWidth >= 768) {
              this.activeEpisode = this.screenContent.EpisodesLinks[0]
            }
          }
        }
      }
    },
    setActiveEpisode (episode) {
      clearTimeout(this.activeTimeout)
      this.activeEpisode = episode
      if (this.activeEpisode) {
        this.$gtm.trackEvent({
          'event': 'Tutorial Click',
          'lp_tutorialName': this.activeEpisode.Title
        })
      }
    },
    checkEpisodeActive (episode) {
      let isActive = false
      if (this.activeEpisode) {
        if (this.activeEpisode.Title === episode.Title) {
          isActive = true
        }
      }
      return isActive
    },
    clickPlayNow () {
      this.$gtm.trackEvent({
        'event': 'Play Free Now Click',
        'lp_section': 'Tutorial Special'
      })
      Util.playFree();

    },
    clickFooterLink (name) {
      this.$gtm.trackEvent({
        'event': 'Landing Page Footer Click',
        'lp_footerElement': name
      });
    },
    clickBackToTop () {
      this.$gtm.trackEvent({
        'event': 'Back to Top'
      })
      this.$store.dispatch('setScene', 'night')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/landing/variables.scss';
@import '@/assets/scss/landing/mixins.scss';

.portal__text {
  margin-bottom: 30px;
    @media only screen and (max-height: 440px) and (orientation: landscape) {
      margin-bottom: 10px;
    }
}
.content__inner {
  display: block;
  width: 100%;
}
.container {
  z-index: 3;
  max-width: 1200px;
  margin: 0 auto 10px;
}
.footer__container {
  z-index: 0;
}
.videoembed__background {
  position: fixed;
  z-index: 4;
  background-color: $black;
  opacity: .8;

  @include breakpoint(md) {
    display: none;
  }
}
.videoembed__close {
  position: fixed;
  z-index: 6;
  top: 20px;
  left: 25px;
  display: block;
  cursor: pointer;
  opacity: 1;
  transition: opacity .5s ease;

  &:hover {
    opacity: .7;
  }

  @include breakpoint(md) {
    display: none;
  }
}
.videoembed {
  position: fixed;
  z-index: 5;
  display: none;
  top: 50%;
  left: 0;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  margin-bottom: 20px;
  background-color: $offblack;
  transform: translateY(-50%);

  &.active {
    display: block;
  }

  @include breakpoint(md) {
    position: relative;
    z-index: 0;
    display: block;
    top: 0;
    transform: none;
  }

  iframe {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.videoembed__frame {
  position: absolute;
  z-index: 1;
  top: -5%;
  left: -3%;
  width: 106%;
  height: 110%;
  pointer-events: none;
}
.road {
  position: relative;
  width: 100%;
  margin-bottom: 40px;
  @media only screen and (max-height: 440px) and (orientation: landscape) {
    margin-bottom: 30px;
  }
}
.notice {
  position: relative;
  z-index: 0;
  max-width: 100%;
  width: 400px;
  padding: 50px 20px;
  margin: 0 auto 30px;
  background-color: rgba(0, 0, 0, .3);

  @media only screen and (max-height: 440px) and (orientation: landscape) {
    margin-bottom: 40px;
  }

  p {
    line-height: 2rem;
  }
}
.notice__frame {
  position: absolute;
  z-index: 1;
  top: -5%;
  left: -3%;
  width: 106%;
  height: 110%;
  pointer-events: none;
}
.notice__title {
  margin-bottom: 20px;
}
.logo {
  display: block;
  position: relative;
  z-index: 0;
  width: 140px;
  margin: 0 auto 40px;
}
.flex-row {
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.footer {
  font-size: 1.7rem;
  line-height: 2.6rem;
  margin-bottom: 40px;

  p {
    margin: 0;
  }
  a {
    color: $white;
    margin: 0 10px 5px;
    transition: color .5s ease;

    &:hover {
      color: $grey;
    }
  }
}
.footer__legal {
  text-transform: uppercase;
}
.footer__links {
  justify-content: center;
  margin-bottom: 0px;

  a {
    margin: 0 10px 10px;
    padding: 10px;
    margin: 5px;
    font-size: 20px;

    @include breakpoint(sm) {
      font-size: 40px;
    }
  }
}
.yt-video-container {
  @media only screen and (max-height: 440px) and (orientation: landscape) {
    flex: 0 0 70%;
    max-width: 70%;
  }
}
.btn-wrapper {
  min-width: 100%;
  margin-bottom: 15px;
  @include breakpoint(sm) {
    min-width: initial;
    margin: 15px 10px 10px 10px;
  }
  @include breakpoint(md) {
    margin: 15px 20px 10px 20px;
  }
  @include breakpoint(lg) {
    margin: 15px 40px 10px 40px;
  }
  .btn {
    font-size: 2.2rem;
    padding: 15px 10px;
    min-width: 80%;

    @include breakpoint(sm) {
      min-width: 232px;
      padding: 15px 25px;
    }
  }
}
</style>
